import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { addNCContent } from "../redux/actions/index";

const useNCCharts = (id, items) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (items && items.length > 0) {
      const match = id.match(/\{(.*?)\}/);
      items.forEach( x => {
        try {
          dispatch(addNCContent({ ref: `refC-${x.id}`, link: `link-refC-${x.id}`, action: `class`, scroll: true, order: (match && match[1]) ? match[1] : `A` }));
        } catch(e) {}
      } )
    }
  }, [id, items, dispatch])
  return null;
};

export default useNCCharts;
